import React, { useState, useEffect } from "react";
import "../index.css";
import store from "store";
import { imagePrefixUrl } from "util/config";
import { Link } from "react-router-dom";
import moment from "moment";

const TrainingCampaigns = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [isAuthorized, setIsAuthorized] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [selectedCampaignData, setSelectedCampaignData] = useState(null);
  const [campaignUsers, setCampaignUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const pageLimit = 10;
  let userInfo = store.get("user");

  const formatDateToDDMM = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    return `${day}/${month}`;
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";
    return moment(dateString).format("LLL");
  };

const getTrainingCampaigns = async () => {
    setLoading(true);
    const apiUrl = process.env.REACT_APP_API_URL || "";
    const email = (userInfo && userInfo.email) || "";
    const type = "training";
    const url =
        apiUrl +
        `api/reporting/campaigns?email=${encodeURIComponent(email)}&type=${encodeURIComponent(type)}`;
    const accessToken = localStorage.getItem("accessToken");

    try {
        const res = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: "Bearer " + accessToken,
                "Content-Type": "application/json",
            },
        });

        if (!res.ok) {
            throw res;
        }

        const response = await res.json();
        console.log("Training campaigns API response:", response);
        setCampaigns(
            response && response.data && Array.isArray(response.data)
                ? response.data
                : []
        );
    } catch (err) {
        console.error("Failed to fetch training campaigns:", err);
        if (err.status === 401) {
            localStorage.clear();
            window.location.reload();
        }
    } finally {
        setLoading(false);
    }
};

const getCampaignUsers = async (campaignId, page = 0, search = "") => {
    if (!campaignId) {
        setCampaignUsers([]);
        return;
    }

    setUsersLoading(true);
    const apiUrl = process.env.REACT_APP_API_URL || "";
    const reportingManager = (userInfo && userInfo.email) || "";
    const url =
        apiUrl +
        `api/reporting/campaign-users?campaignIds=${encodeURIComponent(
            campaignId
        )}&reportingManager=${encodeURIComponent(reportingManager)}&page=${page}&searchText=${encodeURIComponent(search)}`;
    const accessToken = localStorage.getItem("accessToken");

    try {
        const res = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: "Bearer " + accessToken,
                "Content-Type": "application/json",
            },
        });

        if (!res.ok) {
            throw res;
        }

        const response = await res.json();
        setCampaignUsers(
            response && response.data && Array.isArray(response.data)
                ? response.data
                : []
        );
        setTotalRecords(response.totalRecords || 0);
        setCurrentPage(page + 1);
    } catch (err) {
        console.error("Failed to fetch campaign users:", err);
        if (err.status === 401) {
            localStorage.clear();
            window.location.reload();
        }
        setCampaignUsers([]);
    } finally {
        setUsersLoading(false);
    }
};

  const handleCampaignChange = (e) => {
    const campaignId = e.target.value;
    setSelectedCampaign(campaignId);
    setSearchText("");
    setCurrentPage(1);
    const campaign = campaigns.find(c => c._id === campaignId);
    setSelectedCampaignData(campaign || null);
    getCampaignUsers(campaignId, 0, "");
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchText(value);
    if (selectedCampaign) {
      getCampaignUsers(selectedCampaign, 0, value);
    }
  };

  const handlePageChange = (page) => {
    getCampaignUsers(selectedCampaign, page - 1, searchText);
  };

  const getStatusBadge = (status) => {
    const STATUS_COLORS = {
      passed: { bg: "#d4edda", color: "#155724" },
      failed: { bg: "#f8d7da", color: "#721c24" },
      completed: { bg: "#d4edda", color: "#155724" },
      "not completed": { bg: "#fff3cd", color: "#856404" },
      "N/A": { bg: "#e2e3e5", color: "#383d41" },
    };
    const colors = STATUS_COLORS[status] || { bg: "#e2e3e5", color: "#383d41" };
    
    return (
      <span
        style={{
          padding: "4px 12px",
          borderRadius: "12px",
          backgroundColor: colors.bg,
          color: colors.color,
          fontSize: "12px",
          display: "inline-block",
        }}
      >
        {status || "N/A"}
      </span>
    );
  };

  const getCompletionStatus = (user) => {
    if (user.completionStatus && user.completionStatus === "completed") {
      return "completed";
    } else if (user.completionStatus && user.completionStatus !== "completed") {
      return "not completed";
    } else if (user.startedAt) {
      return "not completed";
    }
    return "N/A";
  };

  useEffect(() => {
    const checkIsReportingManager = async () => {
      const apiUrl = process.env.REACT_APP_API_URL || "";
      const email = (userInfo && userInfo.email) || "";
      const url = `${apiUrl}api/reporting/is-manager?email=${encodeURIComponent(email)}`;
      const accessToken = localStorage.getItem("accessToken");

      try {
        const res = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: "Bearer " + accessToken,
            "Content-Type": "application/json",
          },
        });

        if (!res.ok) {
          throw res;
        }

        const response = await res.json();
        const isManager =
          response &&
          response.data &&
          response.data.isReportingManager === true;

        if (!isManager) {
          setIsAuthorized(false);
          window.location.href = "/trainee";
          return false;
        }

        setIsAuthorized(true);
        return true;
      } catch (err) {
        if (err.status === 401) {
          setIsAuthorized(false);
          localStorage.clear();
          window.location.reload();
          return false;
        }

        // Fail-safe: do not allow page access when manager status check fails.
        setIsAuthorized(false);
        window.location.href = "/trainee";
        return false;
      }
    };

    const fetchCampaigns = async () => {
      const allowed = await checkIsReportingManager();
      if (!allowed) {
        return;
      }

      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL || "";
      const email = (userInfo && userInfo.email) || "";
      const type = "training";
      const url =
        apiUrl +
        `api/reporting/campaigns?email=${encodeURIComponent(email)}&type=${encodeURIComponent(type)}`;
      const accessToken = localStorage.getItem("accessToken");

      try {
        const res = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: "Bearer " + accessToken,
            "Content-Type": "application/json",
          },
        });

        if (!res.ok) {
          throw res;
        }

        const response = await res.json();
        console.log("Training campaigns API response:", response);
        const campaignsData =
          response && response.data && Array.isArray(response.data)
            ? response.data
            : [];
        setCampaigns(campaignsData);

        // Auto-select the first campaign and load its users
        if (campaignsData.length > 0) {
          const firstCampaign = campaignsData[0];
          setSelectedCampaign(firstCampaign._id);
          setSelectedCampaignData(firstCampaign);
          getCampaignUsers(firstCampaign._id, 0, "");
        }
      } catch (err) {
        console.error("Failed to fetch training campaigns:", err);
        if (err.status === 401) {
          localStorage.clear();
          window.location.reload();
        }
      } finally {
        setLoading(false);
      }
    };

    fetchCampaigns();
  }, []);

  if (isAuthorized !== true) {
    return null;
  }

  const NoDataMessage = () => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        flex: 1,
        padding: "50px",
      }}
    >
      <img
        src={"/assets/NoData.png"}
        alt=""
        style={{ objectFit: "contain", height: "50%", width: "50%" }}
      />
      <h3
        style={{
          textAlign: "center",
          color: "#8c8d8b",
          marginTop: "0px",
        }}
      >
        No training campaigns found.
      </h3>
    </div>
  );

  const NoUsersMessage = () => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        flex: 1,
        padding: "30px",
      }}
    >
      <h4
        style={{
          textAlign: "center",
          color: "#8c8d8b",
          marginTop: "0px",
        }}
      >
        No users found for this campaign.
      </h4>
    </div>
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <div className="welcome-section">
        <h2 className="sub-title" style={{ paddingLeft: "8px" }}>
          Training Campaigns
        </h2>
      </div>

      <div className="welcome-section" style={{ paddingLeft: "28px" }}>
        <h2 className="sub-title">Your Training Campaigns</h2>
      </div>

      {/* Campaign Dropdown */}
      <div style={{ padding: "12px 28px" }}>
        <label
          htmlFor="campaign-select"
          style={{
            display: "block",
            marginBottom: "8px",
            fontWeight: "500",
            color: "#333",
          }}
        >
          Select Campaign:
        </label>
        <select
          id="campaign-select"
          value={selectedCampaign}
          onChange={handleCampaignChange}
          disabled={loading}
          style={{
            width: "100%",
            maxWidth: "400px",
            padding: "10px 12px",
            fontSize: "14px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            backgroundColor: "#fff",
            cursor: loading ? "not-allowed" : "pointer",
          }}
        >
          <option value="" disabled>-- Select a Campaign --</option>
          {campaigns.map((campaign, index) => (
            <option key={campaign.id || index} value={campaign._id}>
              {campaign.name || `Campaign ${index + 1}`}
            </option>
          ))}
        </select>
      </div>

      {/* Users Table */}
      {selectedCampaign && (
        <div style={{ padding: "12px 28px", flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
            <h3 style={{ margin: 0, color: "#333" }}>Campaign Users</h3>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <input
                type="text"
                placeholder="Search..."
                value={searchText}
                onChange={handleSearch}
                style={{
                  padding: "8px 12px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  fontSize: "14px",
                  width: "200px",
                }}
              />
            </div>
          </div>
          {usersLoading ? (
            <div>
              <div className="shimmer-row" style={{ margin: "3px" }}>
                <div className="shimmer-card">
                  <div className="shimmer"></div>
                </div>
                <div className="shimmer-card">
                  <div className="shimmer"></div>
                </div>
              </div>
            </div>
          ) : campaignUsers.length === 0 ? (
            <NoUsersMessage />
          ) : (
            <div style={{ flex: 1, overflowX: "auto", overflowY: "auto", minHeight: 0 }}>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  backgroundColor: "#fff",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  borderRadius: "8px",
                  overflow: "hidden",
                  minWidth: "1200px",
                }}
              >
                <thead style={{ position: "sticky", top: 0, zIndex: 1 }}>
                  <tr
                    style={{
                      backgroundColor: "#011628",
                      borderBottom: "2px solid #010d1a",
                    }}
                  >
                    <th style={{ padding: "12px 16px", textAlign: "left", fontWeight: "600", color: "#fff" }}>
                      Name
                    </th>
                    <th style={{ padding: "12px 16px", textAlign: "left", fontWeight: "600", color: "#fff" }}>
                      Email
                    </th>
                    <th style={{ padding: "12px 16px", textAlign: "left", fontWeight: "600", color: "#fff" }}>
                      Attempted
                    </th>
                    <th style={{ padding: "12px 16px", textAlign: "left", fontWeight: "600", color: "#fff" }}>
                      Completion Status
                    </th>
                    <th style={{ padding: "12px 16px", textAlign: "left", fontWeight: "600", color: "#fff" }}>
                      Score
                    </th>
                    <th style={{ padding: "12px 16px", textAlign: "left", fontWeight: "600", color: "#fff" }}>
                      Result
                    </th>
                    <th style={{ padding: "12px 16px", textAlign: "left", fontWeight: "600", color: "#fff" }}>
                      Assigned At
                    </th>
                    <th style={{ padding: "12px 16px", textAlign: "left", fontWeight: "600", color: "#fff" }}>
                      Started At
                    </th>
                    <th style={{ padding: "12px 16px", textAlign: "left", fontWeight: "600", color: "#fff" }}>
                      Submitted At
                    </th>
                    <th style={{ padding: "12px 16px", textAlign: "left", fontWeight: "600", color: "#fff" }}>
                      Training Attempt
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {campaignUsers.map((user, index) => (
                    <tr
                      key={user._id || index}
                      style={{
                        borderBottom: "1px solid #e0e0e0",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = "#f9f9f9")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor = "#fff")
                      }
                    >
                      <td style={{ padding: "12px 16px", color: "#333" }}>
                        {(user.trainee && user.trainee.userName) || user.name || user.firstName || "--"}
                      </td>
                      <td style={{ padding: "12px 16px", color: "#666" }}>
                        {(user.trainee && user.trainee.email) || user.email || "--"}
                      </td>
                      <td style={{ padding: "12px 16px", color: "#666" }}>
                        {user.startedAt ? "Yes" : "No"}
                      </td>
                      <td style={{ padding: "12px 16px" }}>
                        {getStatusBadge(getCompletionStatus(user))}
                      </td>
                      <td style={{ padding: "12px 16px", color: "#666" }}>
                        {user.scoreRaw !== undefined && user.scoreRaw !== null ? user.scoreRaw : "N/A"}
                      </td>
                      <td style={{ padding: "12px 16px" }}>
                        {getStatusBadge(user.successStatus || "N/A")}
                      </td>
                      <td style={{ padding: "12px 16px", color: "#666" }}>
                        {user.assignedAt ? moment(user.assignedAt).format("LLL") : "N/A"}
                      </td>
                      <td style={{ padding: "12px 16px", color: "#666" }}>
                        {user.startedAt ? moment(user.startedAt).format("LLL") : "N/A"}
                      </td>
                      <td style={{ padding: "12px 16px", color: "#666" }}>
                        {user.submittedAt ? moment(user.submittedAt).format("LLL") : "N/A"}
                      </td>
                      <td style={{ padding: "12px 16px", color: "#666" }}>
                        {user.submissions && user.submissions.length > 0 ? user.submissions.length : 0}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              
              {/* Pagination */}
              {totalRecords > pageLimit && (
                <div style={{ display: "flex", justifyContent: "center", marginTop: "20px", gap: "5px" }}>
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    style={{
                      padding: "8px 12px",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      backgroundColor: currentPage === 1 ? "#f5f5f5" : "#fff",
                      cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    }}
                  >
                    Previous
                  </button>
                  <span style={{ padding: "8px 12px", color: "#666" }}>
                    Page {currentPage} of {Math.ceil(totalRecords / pageLimit)}
                  </span>
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage >= Math.ceil(totalRecords / pageLimit)}
                    style={{
                      padding: "8px 12px",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      backgroundColor: currentPage >= Math.ceil(totalRecords / pageLimit) ? "#f5f5f5" : "#fff",
                      cursor: currentPage >= Math.ceil(totalRecords / pageLimit) ? "not-allowed" : "pointer",
                    }}
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      )}

    
    </div>
  ); 
};

export default TrainingCampaigns;
